/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Page_ViewsInputs */

const en_admin_funnel_history_page_views = /** @type {(inputs: Admin_Funnel_History_Page_ViewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser page views`)
};

/**
* | output |
* | --- |
* | "Browser page views" |
*
* @param {Admin_Funnel_History_Page_ViewsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_page_views = /** @type {((inputs?: Admin_Funnel_History_Page_ViewsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Page_ViewsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_page_views(inputs)
});
export { admin_funnel_history_page_views as "admin.funnel.history.page_views" }